const expertiseSX = {
    border: "1px solid black !important",
    borderRadius: "20px !important",
    height: "60px",
    color: "black",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "rgb(52, 143, 27, 0.5) !important",
      // border: "1px solid #82D782 !important",
    },
    "&:focus": {
      backgroundColor: "rgb(52, 143, 27, 0.5) !important",
      // border: "1px solid #82D782 !important",
    },
    "&.Mui-selected": {
      backgroundColor: "#82D782 !important",
      border: "1px solid #82D782 !important",
    }, 
   
  };
  export default expertiseSX